var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53169 6.5078L2.46304 0.423632C1.89964 -0.14121 0.985949 -0.14121 0.422549 0.423632C-0.14085 0.988472 -0.14085 1.9045 0.42255 2.46934L7.51144 9.57637C8.07484 10.1412 8.98854 10.1412 9.55194 9.57637C9.55371 9.57459 9.55593 9.57236 9.55771 9.57014C9.55993 9.56791 9.5617 9.56613 9.56392 9.56435L16.5773 2.53299C16.8593 2.25035 17 1.88047 17 1.51014C17 1.13981 16.8593 0.769923 16.5773 0.487281C16.0139 -0.0775602 15.1002 -0.0775601 14.5368 0.487281L8.53169 6.5078Z",
    fill: "#726FB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.edaccf52944b29c3aaf849e95df6e15a.svg";
export { ForwardRef as ReactComponent };